"use client";
import React from "react";
import Link from "next/link";
import { SingleProductDescriptionFocused } from "../singleProduct/singleProductDescriptionFocused";
import { SingleProductImageFocused } from "../singleProduct/singleProductImageFocused";
import { giftCardItem, giftCardRoute } from "@/utils/giftCardUtils";
import { ItemList } from "../itemList/itemList";
import { getItemUrl } from "@/utils/itemUrlUtils";

interface ItemsProps {
  itemTemplate?: string;
  items: any[];
  isRetailMerchant: boolean;
  merchantName: string;
}

export const Items = ({
  itemTemplate,
  items,
  isRetailMerchant,
  merchantName,
}: ItemsProps) => {
  return (
    <div className="pt-8">
      <ItemList listType={itemTemplate?.toLowerCase()}>
        {itemTemplate?.toLowerCase() === "image focused" &&
          items.map((product: any) => (
            <Link
              href={
                product.id !== giftCardItem.id
                  ? `/${getItemUrl(product)}`
                  : giftCardRoute
              }
              key={product.id}
            >
              <SingleProductImageFocused
                product={product}
                isRetailMerchant={isRetailMerchant}
              />
            </Link>
          ))}
        {itemTemplate?.toLowerCase() === "description focused" &&
          items.map((product: any) => (
            <Link
              href={
                product.id !== giftCardItem.id
                  ? `/${getItemUrl(product)}`
                  : giftCardRoute
              }
              key={product.id}
            >
              <SingleProductDescriptionFocused
                merchantName={merchantName}
                product={product}
                key={product.id}
                isRetailMerchant={isRetailMerchant}
              />
            </Link>
          ))}
      </ItemList>
    </div>
  );
};
